import { ESettingsSectionType } from './types';

export const CLASS_SETTINGS_SECTION = 'settings-section';
export const CLASS_SETTINGS_SECTION_EMPTY = 'settings-section--empty';

export const getPopupAttributes = () => ({
    sectionType: ESettingsSectionType.POPUP
});
